import React from 'react';
import TicketReply from '../ReusedComponents/TicketReply'
import { useParams, useHistory } from 'react-router-dom'

export default function AdminTicket() {
    const history = useHistory();
    const { uid, ssid } = useParams();

    // On a direct visit/refresh there is no navigation state, so guard it —
    // reading .userType off undefined was crashing the whole page.
    const navState = history.location.state || {};

    return (
        <div className="totalTicketingModule">

            <TicketReply
                userType={navState.userType || "superadmin"}
                title={navState.title || "Ticket Details"}
                options={[{ title: "Dashboard", url: `/tickets/superadmin/dashboard/${ssid}/${uid}` }, { title: "Reports", url: `/tickets/superadmin/reports/${ssid}/${uid}` }]}
            />

        </div>
    )
}